import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { MenuItem, Select, TextField } from "@mui/material";
import {
  deleteSupport,
  editSupport,
  getSupport,
  getSupportById,
} from "../../../service/api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import { sanitizeInput } from "../../../config/validation";
import { triggerDownload } from "../../../config/downloadUtils";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import ReactSelect from "react-select";
import moment from "moment";

const formatDateTime = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const ALL_COLUMNS = [
  {
    key: "title",
    title: "Title",
    defaultVisible: true,
    render: (r) => r?.title || "-",
  },
  {
    key: "type",
    title: "Type",
    defaultVisible: true,
    render: (r) => r?.type || "-",
  },
  {
    key: "user",
    title: "User",
    defaultVisible: true,
    render: (r) => {
      const fn = r?.userId?.firstName || r?.firstName;
      const ln = r?.userId?.lastName || r?.lastName;
      const email = r?.userId?.email || r?.email;
      const name = `${fn || ""} ${ln || ""}`.trim();
      return name || email || "-";
    },
  },
  {
    key: "email",
    title: "Email",
    defaultVisible: false,
    render: (r) => r?.userId?.email || r?.email || "-",
  },
  {
    key: "status",
    title: "Status",
    defaultVisible: true,
    render: (r) => r?.status || "-",
  },
  {
    key: "adminReplay",
    title: "Admin Reply",
    defaultVisible: true,
    render: (r) => r?.adminReplay || "-",
  },
  {
    key: "createdAt",
    title: "Created",
    defaultVisible: false,
    render: (r) => formatDateTime(r?.createdAt),
  },
  {
    key: "updatedAt",
    title: "Updated",
    defaultVisible: false,
    render: (r) => formatDateTime(r?.updatedAt),
  },
];

const statusOptions = [
  { label: "Active", value: "ACTIVE" },
  { label: "In Progress", value: "IN-PROGRESS" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Reject", value: "REJECT" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "100%",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
  indicatorSeparator: () => ({ display: "none" }),
};

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  // border: '1px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const Support = () => {
  const [roleInput, setroleInput] = useState({
    msg: "",
    status: "",
  });
  const [roleInputError, setroleInputError] = useState({
    msg: false,
    status: false,
  });
  const [supportList, setSupportList] = useState([]);
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [id, setId] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState();

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "support-list",
    allColumns: ALL_COLUMNS,
  });

  const roleChange = (e) => {
    const { name, value } = e.target;
    setroleInput({ ...roleInput, [name]: sanitizeInput(value) });
    setroleInputError({ ...roleInputError, [name]: false });
  };

  const getUserList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }
    if (statusFilter?.value) {
      body.status = statusFilter.value;
    }

    setLoading(true);
    getSupport(body)
      .then((res) => {
        if (res?.status) {
          setSupportList(res?.data);
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (searchTerm) body.search = searchTerm;
    if (statusFilter?.value) body.status = statusFilter.value;
    setDownloadLoading(true);
    getSupport(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "support");
      })
      .finally(() => setDownloadLoading(false));
  };

  const handleClear = () => {
    setroleInput({
      ...roleInput,
      msg: "",
      status: "",
    });
    setroleInputError({
      msg: false,
      status: false,
    });
  };
  // ADD USER FUNCTION
  const addUserFun = () => {
    console.log(roleInput);

    if (!roleInput?.msg && !roleInput?.status) {
      setroleInputError({
        ...roleInputError,
        msg: true,
        status: true,
      });
      return;
    } else if (!roleInput?.msg) {
      setroleInputError({ ...roleInputError, msg: true });
      return;
    } else if (!roleInput?.status) {
      setroleInputError({ ...roleInputError, status: true });
      return;
    }
    if (roleInput) {
      setLoading(true);

      let obj = {
        adminMessage: roleInput?.msg,
        status: roleInput?.status,
      };
      editSupport(id?._id, obj)
        .then((res) => {
          console.log("response api", res);
          if (res?.status) {
            toast.success(res?.message, { toastId: 'support-reply-success' });
            setEdit(false);
            setUser(false);
            getUserList();
            handleClear();
          } else {
            toast.error(res?.message, { toastId: 'support-reply-error' });
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message, { toastId: 'support-reply-error' });
        })
        .finally((res) => {
          setLoading(false);
        });
    }
  };
  // DELETE USER FUNCTION

  const handleDeleteFunction = () => {
    setLoading(true);
    deleteSupport(id?._id)
      .then((res) => {
        console.log("res: ", res);
        if (res?.status) {
          toast.success(res?.message, { toastId: 'support-close-success' });
          handleCloseDelete();
          getUserList();
          setId(null);
        } else {
          toast.error(res?.message, { toastId: 'support-close-error' });
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message, { toastId: 'support-close-error' });
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getUserList();
  }, [page, pageSize, searchTerm, statusFilter]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, searchTerm, statusFilter]);

  const getUserDataById = (id) => {
    getSupportById(id)
      ?.then((res) => {
        console.log("%c Line:264 🍻 res", "color:#6ec1c2", res);
        if (res?.status) {
          let data = res?.data;
          setroleInput({
            ...roleInput,
            status: data?.status,
          });
        }
      })
      .catch((e) => {
        console.log("%c Line:267 🥟 e", "color:#fca650", e);
      });
  };
  const getUserFun = (e) => {
    if (e && supportList && supportList?.length > 0) {
      let arr = supportList?.find((obj) => obj?._id === e);
      return `${arr?.firstName} ${arr?.lastName}`;
    }
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        <a
          className="me-1 btn btn-sm bg-success-light "
          onClick={() => {
            setId(row);
            handleClear();
            setUser(true);
            setEdit(true);
            getUserDataById(row?._id);
          }}
        >
          <i className="fe fe-pencil"></i> Edit
        </a>
        <a
          onClick={() => {
            handleOpenDelete();
            setId(row);
          }}
          className="me-1 btn btn-sm bg-danger-light"
        >
          <i className="fe fe-trash"></i> Delete
        </a>
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Support</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Support</li>
                </ul>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              {user ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0px",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <FaArrowLeft
                        style={{
                          marginTop: "3px",
                          cursor: "pointer",
                          width: "30px",
                          height: "20px",
                        }}
                        onClick={() => {
                          setEdit(false), setUser(false);
                        }}
                      />
                      <h4>{edit ? "Edit User" : "Add User"}</h4>
                    </div>{" "}
                    <div
                      style={{
                        // borderTop: "1px solid grey",
                        height: "56px",
                        display: "flex",
                        justifyContent: "end",
                        // marginTop: "30px",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={addUserFun}
                        disabled={loading}
                        style={{ marginBottom: "10px", marginTop: "9px" }}
                      >
                        {loading ? (
                          <Spinner size="sm" />
                        ) : edit ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                  </div>
                  <div style={{ margin: "10px" }} className="page-grid">
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Admin message &nbsp;
                        {roleInputError?.msg && (
                          <small style={{ color: "red" }}>
                            {"Message is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="First Name"
                        value={roleInput?.msg}
                        onChange={roleChange}
                        name="msg"
                        id="msg"
                      />
                    </div>

                    <div style={{ margin: "10px", textAlign: "left" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Status
                      </InputLabel>
                      <Select
                        // labelId="demo-simple-select-label"
                        // id="demo-simple-select"
                        className="form-control select-sorting"
                        placeholder="Update Status"
                        value={roleInput?.status}
                        onChange={(e) =>
                          setroleInput({ ...roleInput, status: e.target.value })
                        }
                        style={{
                          border: "none",
                          padding: 0,
                          width: "100%",
                          height: "56px",
                        }}
                      >
                        <MenuItem style={{ height: "40px" }} value={"ACTIVE"}>
                          Active
                        </MenuItem>
                        <MenuItem
                          style={{ height: "40px" }}
                          value={"IN-PROGRESS"}
                        >
                          In-Progress
                        </MenuItem>
                        <MenuItem
                          style={{ height: "40px" }}
                          value={"COMPLETED"}
                        >
                          Completed
                        </MenuItem>
                        <MenuItem style={{ height: "40px" }} value={"REJECT"}>
                          Reject
                        </MenuItem>
                      </Select>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="list-layout">
                  <div className="list-layout__main">
                    <div className="card">
                      <div className="card-body">
                        <TableToolbar
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pageSizeOptions={pageSizeOptions}
                          total={supportList?.total}
                          page={page}
                          visibleColumnKeys={visibleColumnKeys}
                          allColumns={ALL_COLUMNS}
                          toggleColumn={toggleColumn}
                          resetColumns={resetColumns}
                          onDownload={handleDownload}
                          downloadLoading={downloadLoading}
                        />
                        <div className="table-responsive">
                          {loading ? (
                            <div className="his-spin">
                              <Spin
                                size="large"
                                style={{ position: "relative", top: "35%" }}
                              />
                            </div>
                          ) : (
                            <Table
                              pagination={false}
                              style={{ overflowX: "auto" }}
                              columns={columns2}
                              dataSource={
                                supportList ? supportList?.result : []
                              }
                              rowKey={(record) => record._id || record.id}
                            />
                          )}
                          {supportList && supportList?.total > pageSize && (
                            <CustomPagination
                              key={`pg-${pageSize}`}
                              totalTabs={supportList?.total}
                              tabsPerPage={pageSize}
                              handleChange={setPage}
                              className={`${
                                loading ? "display-hide" : "display-flex"
                              }`}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="list-layout__filters">
                    <FilterPanel
                      count={supportList?.total}
                      onClear={() => {
                        setSearchTerm("");
                        setStatusFilter(null);
                      }}
                    >
                      <FilterPanel.Field label="Search">
                        <input
                          type="text"
                          placeholder="Title or type"
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerm(sanitizeInput(e.target.value))
                          }
                        />
                      </FilterPanel.Field>
                      <FilterPanel.Field label="Status">
                        <ReactSelect
                          options={statusOptions}
                          value={statusFilter || null}
                          onChange={(opt) => setStatusFilter(opt)}
                          styles={customStyles}
                          placeholder="Any"
                          isClearable
                        />
                      </FilterPanel.Field>
                    </FilterPanel>
                  </div>
                </div>
              )}
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Support;
